import { rackSizeOptions } from "@/common/const";
import {
  customerCurrency,
  includedOptions,
} from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const rackAndSpaceQuoteLineFormStrategy: FormFieldsStrategyType[] = [
  {
    label: "Currency",
    name: "targetCurrency",
    required: false,
    readonly: true,
    inputType: "select",
    options: customerCurrency,
  },
  {
    inputType: "text",
    label: "OTC",
    name: "targetOTC",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "MRC",
    name: "targetMRC",
    required: false,
    readonly: true,
  },

  {
    inputType: "text",
    label: "Quote Type",
    required: false,
    readonly: true,
    name: "quoteType",
  },
  {
    inputType: "text",
    label: "Quantity",
    name: "quantity",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "Rack Size",
    name: "rackSize",
    required: false,
    readonly: true,
    options: rackSizeOptions,
  },
  {
    inputType: "text",
    label: "Power",
    name: "power",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: false,
    readonly: true,
    options: [...contractTermsOptions],
  },

  {
    inputType: "select",
    label: "Local Tax/VAT*",
    name: "isLocalTax",
    required: false,
    readonly: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Local Tax/VAT (in %)",
    name: "localTax",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    readonly: true,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];
export default rackAndSpaceQuoteLineFormStrategy;
